import { render, staticRenderFns } from "./ExamDefinitionTable.vue?vue&type=template&id=bedd42e8"
import script from "./ExamDefinitionTable.vue?vue&type=script&lang=js"
export * from "./ExamDefinitionTable.vue?vue&type=script&lang=js"
import style0 from "./ExamDefinitionTable.vue?vue&type=style&index=0&id=bedd42e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports